export class VideoSoundControl {
  private el: HTMLVideoElement;

  constructor(el: HTMLVideoElement) {
    this.el = el;
    this.setupSoundControls();
  }

  setupSoundControls() {
    if (!this.el.muted) {
      this.videoBlock!.classList.add("sound-enabled");
    }

    const button = document.createElement("button");
    button.className = "video-mute-toggle w-10 h-10 p-2 flex items-center justify-center cursor-pointer absolute bottom-1 right-1 md:bottom-4 md:right-4";
    button.setAttribute("aria-label", "Toggle video sound");
    button.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="speaker-on" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="80" y1="88" x2="80" y2="168" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M192,106.85a32,32,0,0,1,0,42.3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M221.67,80a72,72,0,0,1,0,96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>
    <svg xmlns="http://www.w3.org/2000/svg" class="speaker-off" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><path d="M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="240" y1="104" x2="192" y2="152" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="240" y1="152" x2="192" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="80" y1="88" x2="80" y2="168" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>`;

    button.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.el.muted = !this.el.muted;
      this.updateSoundState();
    });

    this.videoBlock!.appendChild(button);
  }

  updateSoundState() {
    const func = this.el.muted ? "remove" : "add";
    this.videoBlock!.classList[func]("sound-enabled");

    if (!this.el.muted) {
      const otherSoundEnabledVideos = document.querySelectorAll(".wp-block-video.sound-enabled video") as NodeListOf<HTMLVideoElement>;

      otherSoundEnabledVideos.forEach((video) => {
        if (video !== this.el) {
          video.muted = true;
          const parentBlock = video.closest(".wp-block-video");
          parentBlock?.classList.remove("sound-enabled");
        }
      });
    }
  }

  get videoBlock(): HTMLElement | null {
    return this.el.closest(".wp-block-video");
  }
}
